export const SET_DATA = 'SET_DATA'
export const SET_ENDPOINT = 'SET_ENDPOINT'
export const SET_FILTERS_DATA = 'SET_FILTERS_DATA'
export const SET_LOADING = 'SET_LOADING'
export const SET_SUBDOMAIN = 'SET_SUBDOMAIN' // Company or public (my) subdomain
export const SET_CONTENT = 'SET_CONTENT' // Should user see public or company content
export const SET_AFTER_LOGIN_PAGE = 'SET_AFTER_LOGIN_PAGE'
